import React, { useImperativeHandle, forwardRef, useState } from 'react'
import PrimeModal from '@/components/primeModal'
import { useTranslation } from 'react-i18next'
import { getKnowledgeItemInstructions } from '@/api/dictionary'

const titleStyle = {
  fontWeight: 'bold',
}

const Instruction = (props: any, ref: any) => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const [data, setData] = useState<any>(null)
  const [imgUrl, setImgUrl] = useState('')

  const getInstructions = async (record: any) => {
    const res = await getKnowledgeItemInstructions({
      id: record.instructionId,
    })
    setData(res)
  }
  const open = async (record: any, type) => {
    setVisible(true)
    if (type === 'detail') {
      getInstructions(record)
    } else {
      setImgUrl(record.instructionUrl)
    }
  }
  const close = () => {
    setVisible(false)
    setImgUrl('')
    setData(null)
  }
  useImperativeHandle(ref, () => ({
    open,
    close,
  }))
  return (
    <PrimeModal title={t('knowledge.instruction')} open={visible} onCancel={close} footer={false} width={800}>
      {imgUrl && <embed src={imgUrl} style={{ width: '100%', height: 800 }} />}
      {data && (
        <div
          style={{
            maxHeight: 800,
            overflow: 'auto',
          }}
        >
          <div>
            {data?.normalName}
            {t('knowledge.instruction')}
          </div>
          <div style={titleStyle}>【{t('knowledge.drugName')}】</div>
          <div>{t('knowledge.txt10')}：</div>
          <div>{data?.normalName}</div>
          <div>{t('knowledge.txt11')}：</div>
          <div>{data?.tradeName}</div>
          <div>{t('knowledge.txt12')}：</div>
          <div>{data?.englishName}</div>
          <div style={titleStyle}>【{t('knowledge.ingredients')}】</div>
          <div>{data?.ingredients}</div>
          <div style={titleStyle}>【{t('knowledge.indications')}】</div>
          <div>{data?.indication}</div>
          <div style={titleStyle}>【{t('knowledge.txt15')}】</div>
          <div>{data?.specs}</div>
          <div style={titleStyle}>【{t('knowledge.usage')}】</div>
          <div>{data?.usageDosage}</div>
          <div style={titleStyle}>【{t('knowledge.adverseReactions')}】</div>
          <div>{data?.adverseReaction}</div>
          <div style={titleStyle}>【{t('knowledge.taboo')}】</div>
          <div>{data?.taboo}</div>
          <div style={titleStyle}>【{t('knowledge.mattersNeedAttention')}】</div>
          <div>{data?.attentionMatter}</div>
          <div style={titleStyle}>【{t('knowledge.txt21')}】</div>
          <div>{data?.elderlyUsage}</div>
          <div style={titleStyle}>【{t('knowledge.txt22')}】</div>
          <div>{data?.interaction}</div>
          <div style={titleStyle}>【{t('knowledge.txt23')}】</div>
          <div>{data?.overdose}</div>
          <div style={titleStyle}>【{t('knowledge.txt24')}】</div> 
          <div>{data?.pharmacologyAndToxicology}</div>
          <div style={titleStyle}>【{t('knowledge.txt25')}】</div> 
          <div>{data?.pharmacokinetics}</div>
          <div style={titleStyle}>【{t('knowledge.txt26')}】</div> 
          <div>{data?.storage}</div>
          <div style={titleStyle}>【{t('knowledge.txt27')}】</div> 
          <div>{data?.pack}</div>
          <div style={titleStyle}>【{t('knowledge.txt28')}】</div> 
          <div>{data?.termOfValidity}</div>
          <div style={titleStyle}>【{t('knowledge.txt29')}】</div> 
          <div>{data?.executiveStandard}</div>
          <div style={titleStyle}>【{t('knowledge.txt30')}】</div> 
          <div>{data?.manufacturer}</div>
        </div>
      )}
    </PrimeModal>
  )
}

export default forwardRef(Instruction)
